import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { map, tap } from 'rxjs';
import { Router } from '@angular/router';
import { KeycloakService } from 'keycloak-angular';

@Injectable({
  providedIn: 'root'
})
export class SettingsService {
  constructor(
    private readonly http: HttpClient,
    private readonly router: Router,
    private readonly keycloakService: KeycloakService,
  ) { }

  public updateSettings(payload: any) {
    return this.http.put<any>(environment.baseURL + '/profile/settings', payload)
      .pipe(map(res => res.data));
  }

}
